import React, { useState, useEffect } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, VStack, HStack, Input, FormControl, FormLabel,
  Box, Badge, useToast, Table, Thead, Tbody, Tr, Th, Td, Flex,
} from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';
import api from '../api';

export default function MileageRatesModal({ isOpen, onClose }) {
  const [rates, setRates] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ rate_per_mile: '', effective_from: '', description: '' });
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  const fetchRates = async () => {
    try { const { data } = await api.get('/mileage/rates'); setRates(data); } catch(e) {}
  };

  useEffect(() => { if (isOpen) fetchRates(); }, [isOpen]);

  const handleSave = async () => {
    if (!form.rate_per_mile || !form.effective_from) { toast({ title: 'Rate and date required', status: 'warning', duration: 2000 }); return; }
    setSaving(true);
    try {
      await api.post('/mileage/rates', form);
      toast({ title: 'Rate added', status: 'success', duration: 1500 });
      setShowForm(false); setForm({ rate_per_mile: '', effective_from: '', description: '' });
      await fetchRates();
    } catch(e) { toast({ title: 'Failed', status: 'error', duration: 2000 }); }
    finally { setSaving(false); }
  };

  const fmtDate = (d) => d ? new Date(d.split('T')[0] + 'T12:00:00').toLocaleDateString('en-GB', { day:'numeric', month:'short', year:'numeric' }) : '—';

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay /><ModalContent>
        <ModalHeader>
          <Flex justify="space-between" pr={8}>Mileage Rates
            <Button size="xs" leftIcon={<FiPlus />} colorScheme="blue" variant="outline"
              onClick={() => setShowForm(!showForm)}>{showForm ? 'Cancel' : 'New Rate'}</Button>
          </Flex>
        </ModalHeader><ModalCloseButton />
        <ModalBody>
          {showForm && (
            <Box bg="blue.50" p={3} borderRadius="md" mb={3}>
              <VStack spacing={2}>
                <HStack w="100%" spacing={2}>
                  <FormControl flex={1}><FormLabel fontSize="xs" mb={0.5}>Rate per Mile (£)</FormLabel>
                    <Input size="sm" type="number" step="0.0001" value={form.rate_per_mile}
                      onChange={e => setForm(p => ({ ...p, rate_per_mile: e.target.value }))} /></FormControl>
                  <FormControl flex={1}><FormLabel fontSize="xs" mb={0.5}>Effective From</FormLabel>
                    <Input size="sm" type="date" value={form.effective_from}
                      onChange={e => setForm(p => ({ ...p, effective_from: e.target.value }))} /></FormControl>
                </HStack>
                <FormControl><FormLabel fontSize="xs" mb={0.5}>Description</FormLabel>
                  <Input size="sm" value={form.description} placeholder="e.g. HMRC approved rate"
                    onChange={e => setForm(p => ({ ...p, description: e.target.value }))} /></FormControl>
                <Button size="xs" bg="brand.600" color="white" _hover={{ bg:'brand.700' }}
                  onClick={handleSave} isLoading={saving} alignSelf="flex-end">Save Rate</Button>
              </VStack>
            </Box>
          )}
          <Table size="sm"><Thead><Tr>
            <Th px={2}>From Date</Th><Th px={2}>Rate/Mile</Th><Th px={2}>Description</Th><Th px={2}>Current</Th>
          </Tr></Thead><Tbody>
            {rates.map((r, i) => (
              <Tr key={r.id} bg={i === 0 ? 'green.50' : undefined}>
                <Td px={2}>{fmtDate(r.effective_from)}</Td>
                <Td px={2} fontWeight="700">£{parseFloat(r.rate_per_mile).toFixed(4)}</Td>
                <Td px={2}>{r.description || '—'}</Td>
                <Td px={2}>{i === 0 && <Badge colorScheme="green">Active</Badge>}</Td>
              </Tr>
            ))}
          </Tbody></Table>
        </ModalBody>
        <ModalFooter><Button size="sm" onClick={onClose}>Close</Button></ModalFooter>
      </ModalContent>
    </Modal>
  );
}
